import { ref, inject} from 'vue';
import { apiLink } from './apiLink'
import { deleteData, getData, postData, putData } from './generalio';

const userOperations = () => {
    const error = ref(null)
    
    var hostroot = apiLink
    var endpoint = "useradmin"
    
    const getUserList = () => {
        return getData(endpoint, 'getUserList', 'getUserList')
            //.then(response => response.json())
            .then(result => {return result})
            .catch(err => {
                console.log("Error During getUserList: ", err)
            })
    }

    const userEnableLCR = (userId) => {
        return postData(endpoint + '/' + userId + '/enablelcr', null, 'userEnableLCR', 'userEnableLCR')
        //.then(response => response.json())
        .then(result => {return result})
        .catch(err => {
            console.log("Error During userEnableLCR: ", err)
        })
    }

    const userDisableLCR = (userId) => {
        return postData(endpoint + '/' + userId + '/disablelcr', null, 'userEnableLCR', 'userEnableLCR')
        //.then(response => response.json())
        .then(result => {return result})
        .catch(err => {
            console.log("Error During userDisableLCR: ", err)
        })
    }

    const adminToggle = (userId, admin) => {

        return putData(endpoint+"/admin/"+userId, admin, "user", "user")
        .then(res => {
            return res
        })
        .catch(err => {
            console.log("Error During adminToggle: ", err)
        })
    }

    const postUser = (userId, user) => {
        return postData(endpoint+"/"+userId, user, "user", "user")
        .then(res => {
            return res
        })
        .catch(err => {
            console.log("Error During postUser: ", err)
        })
    }

    const deleteUser = (userId) => {
        return deleteData(endpoint+"/"+userId, "user", "user")
        .then(res => {
            return res
        })
        .catch(err => {
            console.log("Error During deleteUser: ", err)
        })
    }

    const checkUserinfo = () => {
        return getData(endpoint+"/info", 'checkUserinfo', 'checkUserinfo')
            //.then(response => response.json())
            .then(result => {return result})
            .catch(err => {
                console.log("Error During checkUserinfo: ", err)
            })
    }
    const checkGuid = (guid) => {
        return getData(endpoint+"/" + guid, 'checkGuid', 'checkGuid')
            //.then(response => response.json())
            .then(result => {return result})
            .catch(err => {
                console.log("Error During checkGuid: ", err)
                throw err;
            })
    }

    return { userEnableLCR, userDisableLCR, getUserList, adminToggle, postUser, deleteUser, checkUserinfo, checkGuid }
}

export default (userOperations)
